import {useQuery} from "@tanstack/react-query";
import {ChallengesApi, PrizePool} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";

export const GET_CHALLENGE_PRIZES_WON_KEY = "challenge-prizes-won";

export function useGetChallengePrizesWon(newPrizesOnly?: boolean) {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    return useQuery<PrizePool[]>({
        queryKey: [GET_CHALLENGE_PRIZES_WON_KEY, fullToken?.id, newPrizesOnly],
        queryFn: async () => {
            return new ChallengesApi(getConfig(fullToken)).getChallengePrizesWon({
                newPrizesOnly,
            });
        },
        enabled: Boolean(fullToken),
        refetchInterval: 1000 * 60, // Poll every minute
    });
}
